import React from 'react';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" data-id="element-595">
      <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" data-id="element-596">
        <div className="flex items-center justify-between p-6 border-b border-stone-200" data-id="element-597">
          <h3 className="text-2xl font-bold text-stone-900" data-id="element-598">{title}</h3>
          <button onClick={onClose} className="p-2 hover:bg-stone-100 rounded-lg transition-all duration-300 hover:scale-110 transform" data-id="element-599">
            <XIcon className="w-6 h-6 text-stone-600" data-id="element-600" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto max-h-[calc(80vh-88px)]" data-id="element-601">
          {children}
        </div>
      </div>
    </div>;
}